import { GOVGR_HEADING_S, GOVGR_HINT } from "../../conf/styles/GovGrFileInput";

const Label = ({ label, hint }) => {
  return (
    <>
      <span role="heading" aria-level="1" className={GOVGR_HEADING_S}>
        {label}
      </span>
      {hint && <p className={GOVGR_HINT}> {hint} </p>}
    </>
  );
};

export default Label;
